'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _DeprecatedRequestStatus = require('conversations-internal-schema/deprecated-request-status/records/DeprecatedRequestStatus');

var _DeprecatedRequestStatus2 = _interopRequireDefault(_DeprecatedRequestStatus);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var RequestStatusTypes = _interopRequireWildcard(_RequestStatusTypes);

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

var _immutable = require('immutable');

var _ActionTypes = require('../../connected-accounts/constants/ActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _DeprecatedRequestStatus2.default();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SET_CURRENT_CHANNEL, function (state, action) {
  var channel = action.payload.channel;

  var widgetStatus = state.getIn(['chatHistoryFetchStatus', _stubbedChannel.STUBBED_CHANNEL]);

  if (!widgetStatus) return state;

  return state.setIn(['chatHistoryFetchStatus', channel], widgetStatus);
}), _defineProperty(_handleActions, ActionTypes.GET_MESSAGES, function (state) {
  return state.set('messagesFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_MESSAGES_FAILED, function (state) {
  return state.set('messagesFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_MESSAGES_SUCCEEDED, function (state) {
  return state.set('messagesFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_CONVERSATIONS, function (state) {
  return state.set('conversationsFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_CONVERSATIONS_FAILED, function (state) {
  return state.merge({
    conversationsFetchStatus: RequestStatusTypes.FAILED,
    conversationsFilterStatus: RequestStatusTypes.FAILED
  });
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.GET_CONVERSATIONS_SUCCEEDED, ActionTypes.GET_PAGINATED_CONVERSATIONS_SUCCEEDED), function (state) {
  return state.merge({
    conversationsFetchStatus: RequestStatusTypes.SUCCEEDED,
    conversationsFilterStatus: RequestStatusTypes.SUCCEEDED
  });
}), _defineProperty(_handleActions, ActionTypes.GET_INITIAL_CONVERSATION, function (state) {
  return state.set('initialConversationFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_INITIAL_CONVERSATION_FAILED, function (state) {
  return state.set('initialConversationFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_INITIAL_CONVERSATION_SUCCEEDED, function (state) {
  return state.set('initialConversationFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_CHAT_HISTORY, function (state, action) {
  var channel = action.payload.channel;

  return state.setIn(['chatHistoryFetchStatus', channel], RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.SET_THREAD_FILTER, ActionTypes.SET_SEARCH_TEXT), function (state) {
  return state.merge({
    chatHistoryFetchStatus: (0, _immutable.Map)(),
    conversationsFilterStatus: RequestStatusTypes.PENDING
  });
}), _defineProperty(_handleActions, ActionTypes.GET_CHAT_HISTORY_FAILED, function (state, action) {
  var channel = action.payload.channel;

  return state.setIn(['chatHistoryFetchStatus', channel], RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_CHAT_HISTORY_SUCCEEDED, function (state, action) {
  var channel = action.payload.channel;

  return state.setIn(['chatHistoryFetchStatus', channel], RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_MESSAGE, function (state) {
  return state.set('messageUpdateStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_MESSAGE_FAILED, function (state) {
  return state.set('messageUpdateStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.UPDATE_MESSAGE_SUCCEEDED, ActionTypes.TOGGLE_MESSAGE_STATUS), function (state) {
  return state.set('messageUpdateStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_USER_SETTINGS, function (state) {
  return state.set('userSettingsFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_USER_SETTINGS_SUCCEEDED, function (state) {
  return state.set('userSettingsFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_USER_SETTINGS_FAILED, function (state) {
  return state.set('userSettingsFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_USER_SETTINGS, function (state) {
  return state.set('userSettingsUpdateStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_USER_SETTINGS_SUCCEEDED, function (state) {
  return state.set('userSettingsUpdateStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_USER_SETTINGS_FAILED, function (state) {
  return state.set('userSettingsUpdateStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_PORTAL_SETTINGS, function (state) {
  return state.set('portalSettingsFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_PORTAL_SETTINGS_SUCCEEDED, function (state) {
  return state.set('portalSettingsFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_PORTAL_SETTINGS_FAILED, function (state) {
  return state.set('portalSettingsFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_PORTAL_SETTINGS, function (state) {
  return state.set('portalSettingsUpdateStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_PORTAL_SETTINGS_SUCCEEDED, function (state) {
  return state.set('portalSettingsUpdateStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_PORTAL_SETTINGS_FAILED, function (state) {
  return state.set('portalSettingsUpdateStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.SEND_VISITOR_EMAIL_ADDRESS, function (state) {
  return state.set('sendVisitorEmailAddressStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED, function (state) {
  return state.set('sendVisitorEmailAddressStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.SEND_VISITOR_EMAIL_ADDRESS_FAILED, function (state) {
  return state.set('sendVisitorEmailAddressStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_CONTACT_SUCCEEDED, function (state) {
  return state.set('fetchContactStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_CONTACT_FAILED, function (state) {
  return state.set('fetchContactStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_CONTACT, function (state) {
  return state.set('fetchContactStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.CLEAR_CONTACT, function (state) {
  return state.set('fetchContactStatus', RequestStatusTypes.UNINITIALIZED);
}), _defineProperty(_handleActions, ActionTypes.GET_USERS, function (state) {
  return state.set('usersFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_USERS_SUCCEEDED, function (state) {
  return state.set('usersFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_USERS_FAILED, function (state) {
  return state.set('usersFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_TEAMS, function (state) {
  return state.set('teamsFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_TEAMS_SUCCEEDED, function (state) {
  return state.set('teamsFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_TEAMS_FAILED, function (state) {
  return state.set('teamsFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_SNIPPETS, function (state) {
  return state.set('snippetsFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_SNIPPETS_SUCCEEDED, function (state) {
  return state.set('snippetsFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_SNIPPETS_FAILED, function (state) {
  return state.set('snippetsFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_SMART_LISTS, function (state) {
  return state.set('smartListsFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_SMART_LISTS_SUCCEEDED, function (state) {
  return state.set('smartListsFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_SMART_LISTS_FAILED, function (state) {
  return state.set('smartListsFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA, function (state) {
  return state.set('widgetData', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA_SUCCEEDED, function (state) {
  return state.set('widgetData', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA_FAILED, function (state) {
  return state.set('widgetData', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.RESET_STATUS, function (state, action) {
  return state.set(action.payload.key, RequestStatusTypes.UNINITIALIZED);
}), _defineProperty(_handleActions, ActionTypes.GET_AGENT_STATUS, function (state) {
  return state.set('agentStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_AGENT_STATUS_FAILED, function (state) {
  return state.set('agentStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_AGENT_STATUS_SUCCEEDED, function (state) {
  return state.set('agentStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_VISITOR_THREADS_SUCCESS, function (state) {
  return state.set('threadListStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_VISITOR_THREADS_FAILURE, function (state) {
  return state.set('threadListStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_IS_SLACK_INSTALLED, function (state) {
  return state.set('installedIntegrationFetchStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_IS_SLACK_INSTALLED_SUCCESS, function (state) {
  return state.set('installedIntegrationFetchStatus', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.GET_IS_SLACK_INSTALLED_FAILURE, function (state) {
  return state.set('installedIntegrationFetchStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, _ActionTypes.FETCH_CONNECTED_ACCOUNTS, function (state) {
  return state.set('fetchConnectedAccounts', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, _ActionTypes.FETCH_CONNECTED_ACCOUNTS_SUCCEEDED, function (state) {
  return state.set('fetchConnectedAccounts', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes.FETCH_CONNECTED_ACCOUNTS_FAILED, function (state) {
  return state.set('fetchConnectedAccounts', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_UNKNOWN_RESPONDERS, function (state) {
  return state.set('fetchUnknownResponders', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.GET_UNKNOWN_RESPONDERS_FAILED, function (state) {
  return state.set('fetchUnknownResponders', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.GET_UNKNOWN_RESPONDERS_SUCCEEDED, function (state) {
  return state.set('fetchUnknownResponders', RequestStatusTypes.SUCCEEDED);
}), _defineProperty(_handleActions, ActionTypes.SAVE_STAGED_CONNECTED_ACCOUNT, function (state) {
  return state.set('connectedAccountUpdateStatus', RequestStatusTypes.PENDING);
}), _defineProperty(_handleActions, ActionTypes.SAVE_STAGED_CONNECTED_ACCOUNT_FAILED, function (state) {
  return state.set('connectedAccountUpdateStatus', RequestStatusTypes.FAILED);
}), _defineProperty(_handleActions, ActionTypes.SAVE_STAGED_CONNECTED_ACCOUNT_SUCCEEDED, function (state) {
  return state.set('connectedAccountUpdateStatus', RequestStatusTypes.SUCCEEDED);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/request-status/reducers/requestStatus.js
// module id = 1275
// module chunks = 3